/**
 * Copyright 2023 LiveKit, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { LayoutProps } from './common';
import PrimaryHostLayout from './PrimaryHostLayout';
import ParticipantTileWithFallback from './ParticipantTileWithFallback';

const SpeakerLayout = ({ tracks: references }: LayoutProps) => {
  if (references.length === 0) {
    return <></>;
  } else if (references.length === 1) {
    return (
      <div className="lk-grid-layout">
        <ParticipantTileWithFallback trackRef={references[0]} />
      </div>
    );
  }

  const speakers = references.filter((track) => track.participant.isSpeaking);
  if (speakers.length > 1 || speakers.length === 0) {
    return <PrimaryHostLayout tracks={references} />;
  }
  return (
    <div className="lk-grid-layout">
      <ParticipantTileWithFallback trackRef={speakers[0]} />
    </div>
  );
};

export default SpeakerLayout;
